/**
 * 任意の値を安全に文字列化します。
 *
 * 主な用途は `new Error(safeStringify(value))` のように Error コンストラクタへ渡すこと。
 * Error コンストラクタは string を期待しており、オブジェクトをそのまま渡すと暗黙の String() 変換で
 * "[object Object]" になってしまうため、明示的に JSON 化したうえで渡す必要があります。
 *
 * JSON.stringify が循環参照などで例外を投げた場合は String() にフォールバックします。
 * フォールバック時のオブジェクトは "[object Object]" になりますが、呼び出し元が落ちないことを優先します。
 */
export function safeStringify(value: unknown): string {
  try {
    // Error は message/name/stack が non-enumerable で JSON.stringify が "{}" になるため、
    // toString() 経由で "Error: message" 形式の文字列を返す
    if (value instanceof Error) return String(value);
    if (typeof value === "object" && value !== null) {
      // JSON.stringify は toJSON() が undefined を返す等で undefined を返し得るためフォールバックする
      return JSON.stringify(value) ?? String(value);
    }
    return String(value);
  } catch {
    return String(value);
  }
}
